import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  createCashPayment,
  checkCashPaymentStatus,
} from "../features/payment/paymentThunks";
import { clearCashPayment } from "../features/payment/paymentSlice";

const useCashPayment = ({ autoReload = false } = {}) => {
  const dispatch = useDispatch();

  const { cashPaymentData, status, payment_status } = useSelector(
    (state) => state.payment
  );

  /* ---------------- START CASH PAYMENT ---------------- */
  const startCashPayment = ({ bookingId, amount, paymentFor }) => {
    dispatch(
      createCashPayment({
        bookingId,
        amount,
        paymentFor,
      })
    );
  };

  /* ---------------- POLLING ---------------- */
  useEffect(() => {
    if (!cashPaymentData?.orderId || payment_status === "paid") return;

    const interval = setInterval(() => {
      dispatch(checkCashPaymentStatus(cashPaymentData.orderId));
    }, 3000);

    return () => clearInterval(interval);
  }, [cashPaymentData?.orderId, payment_status, dispatch]);

  /* ---------------- AUTO RELOAD ---------------- */
  // useEffect(() => {
  //   if (payment_status === "paid" && autoReload) {
  //     setTimeout(() => {
  //       window.location.reload();
  //     }, 3000);
  //   }
  // }, [payment_status, autoReload]);

  /* ---------------- CLOSE PAYMENT ---------------- */
  const closePayment = () => {
    dispatch(clearCashPayment());
  };

  return {
    startCashPayment,   // ✅ THIS WAS MISSING
    cashPaymentData,
    status,
    payment_status,
    closePayment,
  };
};

export default useCashPayment;
